// Registers page-scoped WebMCP tools (Chrome origin trial) declared by the
// server in data-tools, bridging each tool's execute() into a LiveView
// event whose {:reply, ...} becomes the tool result. Tools live exactly as
// long as the LiveView: the AbortController unregisters them on destroy,
// so navigation always presents the current page's tools.
export const WebMcpTools = {
  mounted() {
    if (!document.modelContext?.registerTool) return;
    this.controller = new AbortController();

    let tools;
    try {
      tools = JSON.parse(this.el.dataset.tools || "[]");
    } catch {
      return;
    }

    tools.forEach((tool) => {
      document.modelContext.registerTool(
        {
          name: tool.name,
          description: tool.description,
          inputSchema: tool.inputSchema,
          annotations: tool.annotations,
          execute: (params) =>
            new Promise((resolve) => {
              this.pushEvent(`webmcp:${tool.name}`, params || {}, (reply) =>
                resolve(JSON.stringify(reply)),
              );
            }),
        },
        { signal: this.controller.signal },
      );
    });
  },

  destroyed() {
    if (this.controller) this.controller.abort();
  },
};
